import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CTAButtonProps = {
  label: string;
  id?: string;
  size?: "lg" | "xl";
  className?: string;
};
export function CTAButton({
  label,
  id,
  size = "lg",
  className = ""
}: CTAButtonProps) {
  const sizing = size === "xl" ? "py-5 sm:py-6 text-[17px] sm:text-xl" : "py-4 sm:py-5 text-[15px] sm:text-lg";
  return <a id={id} href={CHECKOUT_URL} className={`group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold px-5 text-center font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_12px_32px_-10px_rgba(242,193,78,0.75)] ring-1 ring-gold-light/60 transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-gold-light active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-light/60 sm:w-auto sm:px-10 ${sizing} ${className}`} data-id="element-105" data-mp="2ty1ntols11p1">
      <span className="text-balance" data-id="element-106" data-mp="1996a8vutjn9r">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-107" data-mp="19ahfz17tr53i" />
    </a>;
}